export function LoadingScreen({ label = "Loading…" }) {
  return (
    <div className="status-screen" role="status">
      <div className="spinner" />
      <p className="status-label">{label}</p>
    </div>
  );
}

export function ErrorScreen({ message, onRetry }) {
  return (
    <div className="status-screen">
      <h2 className="status-title">Something went wrong</h2>
      <p className="status-label">{message}</p>
      {onRetry && (
        <button className="btn btn-primary" onClick={onRetry}>
          TRY AGAIN
        </button>
      )}
    </div>
  );
}

export function EmptyScreen({ title = "Nothing here yet", message }) {
  return (
    <div className="status-screen">
      <h2 className="status-title">{title}</h2>
      {message && <p className="status-label">{message}</p>}
    </div>
  );
}